import React, { useContext, useEffect, useState } from 'react'
import adminStyles from './adminStyles.module.css'
import AdminSidebar from './AdminSidebar'
import { Outlet, useNavigate } from 'react-router-dom'
import { Store } from '../App'
import axios from 'axios'

const AdminDashboard = () => {
  const[token,setToken]=useContext(Store)
  const[data,setData]=useState("")
  const navigate=useNavigate();

  useEffect(()=>{
  axios.get(`https://backendsurgylife-1.onrender.com/admindashboard`,{
    headers:{
      "y-token":token,
    },
  })
  .then((res)=>{
    setData(res.data)
  })
  .catch(err=>{
    console.log(err)
  })

  })

    if(!token) {
      navigate('/admin')
    } 

  return (
     <main className={adminStyles.adminMain}>
               
                       <section className={adminStyles.breadgum}>
                           <div className='container'>
                               <div className='row'>
                                   <div className='col-md-12'>
                                       <h1>{data} Dashboard</h1>
                                   </div>
                               </div>
                           </div>
                       </section>

                       <section className='py-5'>
                           <div className='container-fluid'>
                            <div className='row'>
                                <div className='col-md-3'>
                                  <AdminSidebar/>
                                </div>

                                <div className='col-md-9'>
                                  <Outlet/>
                                </div>

                            </div>
                           </div>
                       </section>

                       </main>
  )
}

export default AdminDashboard
